import { useNavigate } from "react-router-dom";
import { Colors } from "../Assets/Config/color.config";
import { useEffect, useState } from "react";
import { Cookies } from "react-cookie";
import { inject, observer } from "mobx-react";
import UserMenuItem from "./UserMenuItem";
import LanguageMenuItem from "./LanguageMenuItem";
import "../config";
import { MyConstants } from "../Constants/MyConstants";
import commonStore from "../Store/marco/commonStore";
import { useTranslation } from "react-i18next";
import ImportNotifications from "../import-job/ImportNotifications";

export const NavBar = inject("store")(
  observer((props) => {
    const { role, roleId, userName } = commonStore;
    const navigate = useNavigate();
    const cookies = new Cookies();
    const userRole = cookies.get("role");
    const isBlueOnion = cookies.get("isBlueOnion");
    const { t } = useTranslation("common");

    const [showLanguageDropDown, setShowLanguageDropDown] = useState(false);
    const [showDropDown, setShowDropDown] = useState(false);
    const [notiDropDown, setNotiDropDown] = useState(false);
    const { theme, siteModuleData, customEmissionFactorList, isPCF } =
      props.store.common;
    const { authenticated } = props;
    const _handleLanguageDropDown = (e) => {
      e.stopPropagation();
      setShowDropDown(false);
      setNotiDropDown(false);
      setShowLanguageDropDown(!showLanguageDropDown);
    };

    const _handleNotiDropDown = (e) => {
      e.stopPropagation();
      setShowDropDown(false);
      setShowLanguageDropDown(false);
      setNotiDropDown(!notiDropDown);
    };
    const companyName = siteModuleData?.companyName;

    const _handleUserDropDown = (e) => {
      e.stopPropagation();
      setShowLanguageDropDown(false);
      setNotiDropDown(false);
      setShowDropDown(!showDropDown);
    };

    useEffect(() => {
      const hideDropDowns = (e) => {
        setShowDropDown(false);
        setShowLanguageDropDown(false);
        setNotiDropDown(false);
      };
      document.body.addEventListener("click", hideDropDowns);

      return () => {
        document.body.removeEventListener("click", hideDropDowns);
      };
    }, []);

    const roleFormat = {
      system_admin: "SYSTEM ADMIN",
      super_admin: "SUPER ADMIN",
      admin: "ADMIN",
      operator: "OPERATOR",
      auditor: "AUDITOR",
      senior_admin: "SENIOR ADMIN",
      //"viewer":"VIEWER"
    };

    return (
      <div
        style={{
          height: "55px",
          fontSize: 18,
          color:
            theme === "dark" ? Colors.dark.textColor : Colors.light.textColor,
          background:
            theme === "dark"
              ? "linear-gradient(-60deg, rgb(16, 24, 65), rgb(32, 43, 96))"
              : "linear-gradient(-60deg, rgb(255, 255, 255), rgb(255, 255, 255))",
          borderBottom:
            theme === "dark" ? "1px solid #ffffff20" : "1px solid #00000020",
          zIndex: "400",
        }}
        className="d-flex flex-row justify-content-between align-items-center px-3 py-1 mb-3 fixed-top"
      >
        {/* {authenticated && ( */}
        <>
          <div className="d-flex px-3">
            <h4
              style={{ fontWeight: "bold", cursor: "pointer", margin: 0 }}
              onClick={() =>
                userRole === "auditor"
                  ? navigate("/notifications")
                  : userRole === "translator"
                    ? navigate("/translation-management")
                    : role === MyConstants.CUSTOM_VALIDATOR ||
                        role === MyConstants.SYSTEM_ADMIN
                      ? navigate("/home")
                      : isPCF == "true"
                        ? navigate("/product-carbon-footprint/list")
                        : role === MyConstants.RESELLER
                          ? navigate("/CTBC")
                          : navigate("/emission-view")
              }
            >
              {companyName && companyName === "MEDS" ? (
                <img
                  className="ms-3"
                  src="/MEDS-logo-new.png"
                  height={"60px"}
                />
              ) : (
                <img className="ms-3" src="/nxmap_logo.png" height={"40px"} />
              )}
            </h4>
            <div className="d-flex align-items-center ms-3">
              <p
                style={{
                  color: theme === "dark" ? "#fff" : "#000",
                  fontWeight: "bold",
                  fontSize: 12,
                }}
                className="mb-0 me-3"
              >
                in alignment with
              </p>
              <div
                className="text-center me-2 rounded-pill pe-2"
                style={{
                  backgroundColor:
                    theme == "dark" ? "#ffffff95" : Colors.light.pillColor,
                  paddingTop: "1px",
                  paddingBottom: "1px",
                }}
              >
                <img src="/ghg_protocol_logo.png" height={"30px"} />
              </div>
              <div
                className="text-center rounded-pill pe-2"
                style={{
                  backgroundColor:
                    theme == "dark" ? "#ffffff95" : Colors.light.pillColor,
                  paddingTop: "1px",
                  paddingBottom: "1px",
                }}
              >
                <img className="ms-3" src="/ISO-Logo.png" height={"30px"} />
              </div>
            </div>
          </div>
        </>
        {/* )} */}
        <div
          className="d-flex align-items-center"
          style={{ columnGap: 12, marginLeft: "auto", paddingRight: 8 }}
        >
          {/* {role === MyConstants.SYSTEM_ADMIN && authenticated && (
            <NotiMenuItem
              theme={theme}
              showDropDown={notiDropDown}
              getExpiryUserCount={getExpiryUserCount}
              getAllChildCompanyCount={getAllChildCompanyCount}
              customEmissionFactorList={customEmissionFactorList}
              _handleNotiDropDown={_handleNotiDropDown}
              onClick={_handleNotiDropDown}
            />
          )} */}

          {authenticated && (roleFormat[role] || role) && (
            <span
              className="px-2 py-1 fw-bold"
              variant="outlined"
              style={{
                fontSize: 12,
                borderRadius: "10px",
                color: "white",
                border: theme === "dark" ? "white" : "black",
                backgroundColor:
                  role === "super_admin"
                    ? "#6366f1"
                    : role === "senior_admin"
                      ? "#868ccf"
                      : role === "operator"
                        ? "#3c49bb"
                        : role === "viewer"
                          ? "#4db6ac"
                          : role === "translator"
                            ? "#4db6ac"
                            : role === "admin"
                              ? "#9f8d87"
                              : "#90a4ae",
              }}
            >
              {t(roleFormat[role] || role)}
            </span>
          )}

          <LanguageMenuItem
            userName={userName}
            theme={theme}
            authenticated={authenticated}
            showDropDown={showLanguageDropDown}
            onClick={_handleLanguageDropDown}
          />
          {authenticated && (
            <UserMenuItem
              userName={userName}
              theme={theme}
              role={role}
              isBlueOnion={isBlueOnion}
              authenticated={authenticated}
              showDropDown={showDropDown}
              customEmissionFactorList={customEmissionFactorList}
              onClick={_handleUserDropDown}
            />
          )}
          {authenticated && [2, 3, 4, 6, 7].includes(Number(roleId)) && (
            <ImportNotifications />
          )}
        </div>
      </div>
    );
  }),
);

export default NavBar;
